
const AnswerPresentationSeparator = () => {
  return <hr className="separator" />;
};

export default AnswerPresentationSeparator;
